/**
 * Shows a toast for every broadcast notification sent to the signed-in user or provider.
 * Echo is loaded lazily so guests never download it.
 */
export async function listenForBroadcastNotifications() {
    const { user, provider } = window.Laravel?.__auth ?? {};

    if (!user && !provider) {
        return;
    }

    const { createEcho } = await import('./echo.js');

    const channel = user ? `user.${user}` : `provider.${provider}`;

    createEcho()
        .private(channel)
        .notification((event) => {
            window.toastMagic.info(event.title ?? '', event.message ?? event.body ?? '', true);
        });
}
